<template>
  <div class="container">
    <div class="details">
      <div class="left">
        <a href="/">
          <span class="back material-symbols-outlined">
            arrow_back_ios
          </span>
        </a>
      </div>
      <div class="middle">
        <Tabs />
      </div>
      <div class="right">
        <Zoom />
      </div>
    </div>
    <div class="utils">
      <div class="elements">
        <AddItem v-if="!isBlocked" />
        <Download />
        <Delete v-if="!isBlocked" />
        <Expand v-if="!isBlocked" />
      </div>
      <div class="elements">
        <History v-if="!isBlocked" />
        <Share />
        <Help />
      </div>
    </div>
  </div>
</template>

<script>
import Zoom from './Zoom.vue';
import Share from './TopBar/Share.vue';
import Help from './TopBar/Help.vue';
import Expand from './TopBar/Expand.vue';
import Delete from './TopBar/Delete.vue';
import AddItem from './TopBar/AddItem.vue';
import Download from './TopBar/Download.vue';
import History from './TopBar/History.vue';
import Tabs from './TopBar/Tabs.vue';

import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('creator', [
      'isBlocked',
    ]),
  },
  components: {
    Share,
    Help,
    Delete,
    AddItem,
    Download,
    Expand,
    History,
    Zoom,
    Tabs,
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  background: #fff;
  box-sizing: border-box;
  box-shadow: 0 0 0 2px rgba(100, 100, 100, .05);
}

.elements {
  display: flex;
  /deep/ * ~ * {
    margin-left: 20px;
  }
}

.top {
  border-bottom: 1px solid #ededed;
  padding: 0 10px;
  box-sizing: border-box;
}

.details {
  border-bottom: 2px solid #f1f4fa;
}

.details,
.utils {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.utils {
  background: #fbfbfb;
  padding: 8px 10px;
  box-sizing: border-box;
}

.left span {
  cursor: pointer;
  font-size: 16px;
  padding-left: 16px;
  position: relative;
  top: 2px;
}

</style>
